import { render, staticRenderFns } from "./FormPageBulkSDD.vue?vue&type=template&id=3d5a09fc&scoped=true&"
import script from "./FormPageBulkSDD.vue?vue&type=script&lang=js&"
export * from "./FormPageBulkSDD.vue?vue&type=script&lang=js&"
import style0 from "./FormPageBulkSDD.vue?vue&type=style&index=0&id=3d5a09fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a09fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5a09fc')) {
      api.createRecord('3d5a09fc', component.options)
    } else {
      api.reload('3d5a09fc', component.options)
    }
    module.hot.accept("./FormPageBulkSDD.vue?vue&type=template&id=3d5a09fc&scoped=true&", function () {
      api.rerender('3d5a09fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageBulkSDD.vue"
export default component.exports